import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'excludeKeys',
  standalone: true,
})
export class ExcludeKeysPipe implements PipeTransform {
  transform(
    value: { key: string; value: any }[],
    keysToExclude: string[]
  ): { key: string; value: any }[] {
    if (!value) return value;
    return value.filter(
      (element) => element && !keysToExclude.includes(element.key)
    );
  }
}
